import * as React from 'react'

import './Video.scss'

interface VideoProps {
  src: string
  alt: string
  src768?: string
  src1024?: string
  src1280?: string
  src1600?: string
  src1920?: string
}

const Video: React.FC<VideoProps> = props => {
  return (
    <video autoPlay muted loop className="srprs-video">
      {props.src1920 && (
        <source
          media="(min-width: 1920px)"
          src={props.src1920}
          type="video/mp4"
        />
      )}
      {props.src1600 && (
        <source
          media="(min-width: 1600px)"
          src={props.src1600}
          type="video/mp4"
        />
      )}
      {props.src1280 && (
        <source
          media="(min-width: 1280px)"
          src={props.src1280}
          type="video/mp4"
        />
      )}
      {props.src1024 && (
        <source
          media="(min-width: 1024px)"
          src={props.src1024}
          type="video/mp4"
        />
      )}
      {props.src768 && (
        <source
          media="(min-width: 768px)"
          src={props.src768}
          type="video/mp4"
        />
      )}
      <source src={props.src} type="video/mp4" />
      {props.alt}
    </video>
  )
}

export default Video
